import React from 'react';
import { Box, Image } from '@chakra-ui/react';

interface DataPointProps {
  imageUrl: string;
  className?: string;
  position?: { top: string | number; left: string | number };
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const DataPoint: React.FC<DataPointProps> = ({ 
  imageUrl, 
  className,
  position,
  onMouseEnter,
  onMouseLeave
}) => {
  return (
    <Box
      position="absolute"
      borderRadius="full"
      border="1px"
      borderColor="indigo.400"
      width="35px"
      height="35px"
      overflow="hidden"
      cursor="pointer"
      top={position?.top}
      left={position?.left}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      _hover={{ boxShadow: "0 0 0 2px #6366F1" }}
    >
      <Image 
        src={imageUrl} 
        alt="Company logo" 
        width="100%" 
        height="100%"
        objectFit="cover"
      />
    </Box>
  );
};

export default DataPoint; 